import { useLocation } from 'react-router-dom';
import { FeesProvider } from 'sonata-platform-components';

import { InsertionOrderFormProvider } from '@/components/ioSettings/InsertionOrderForm/InsertionOrderForm.provider';
import { useGlobalStore } from '@/store/global';
import { getUser } from '@/store/global/user/selectors.ts';
import { IoSettingsStore, useStore as useIOSettingsStore } from '@/store/local/ioSettings';

type Props = {
  children?: React.ReactNode;
};

function FormProviderWrapper({ children }: Props) {
  const { state } = useLocation();
  const user = useGlobalStore(getUser);
  const userJSON = user.toJSON();
  const ioState = useIOSettingsStore() as IoSettingsStore;

  return (
    <FeesProvider entity={ioState.entity.toJSON()} user={userJSON}>
      <InsertionOrderFormProvider
        defaultCountries={state?.campaignPlan?.countries}
        defaultInsertionOrder={ioState.entity.toJSON()}
      >
        {children}
      </InsertionOrderFormProvider>
    </FeesProvider>
  );
}

export default FormProviderWrapper;
